// Single source of truth for what the signed-in dashboard user may do.
// Roles: admin | subAdmin | manager | engineer.
//
// "engineer" is an app user (mobile worker) signed in to the dashboard in a
// restricted, forms-only mode: they see their own records and can create new
// forms, but cannot edit or delete anything and cannot reach admin pages.
// The backend enforces the same rules (middleware/engineerAccessGuard.js) —
// this module only drives the UI.

export function getStoredRole() {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    const role = u?.role;
    return typeof role === "string" && role.trim() ? role.trim() : "";
  } catch {
    return "";
  }
}

export function isEngineer() {
  return getStoredRole().toLowerCase() === "engineer";
}

// Managers and engineers are read-only on existing records.
export function canEditDeleteRecords() {
  const role = getStoredRole().toLowerCase();
  return role !== "manager" && role !== "engineer";
}

// Engineers have no admin section at all — only the forms tree.
export function canSeeAdminSections() {
  return !isEngineer();
}
